import $ from 'jquery'
import { trace, setCookie, getCookie } from "rytm-helpers"


const COOKIE_SOUND = "amzn_sound_fx"
const SOUND_PHP_BG = "amznsound-full"

let windowFocus = true
let soundEnabled = getCookie(COOKIE_SOUND) == "off" ? false : true
let bgSoundPlayback = false
const enableSound = () => {
  setCookie(COOKIE_SOUND, "on")
  document.documentElement.classList.remove("sound-disabled")
  soundEnabled = true
  playBgSounds()
}
const disableSound = () => {
  trace("disable AUDIO")
  setCookie(COOKIE_SOUND, "off")
  document.documentElement.classList.add("sound-disabled")
  soundEnabled = false
  bgSoundPlayback = false
  stopAllSound()
}

const onToggleSoundClick = (e) => {
  e.preventDefault();
  toggleSound()
}

let audioArr = []
const getFilePath = (sndName) => {
  switch (sndName) {
    case SOUND_PHP_BG:
      let path = null
      const amznsound = document.querySelector('.amznsound-full')
      if (amznsound) {
        path = amznsound.dataset.audioPath
      }
      return path
    default:
      return "/local/assets/sounds/" + sndName + ".mp3";
  }
}
/**
* get Audio
**/
const getAudio = (sndName) => {  
  let a = false
  audioArr.forEach((audio, index) => {    
    if (audio.sndName == sndName) {
      a = audio
      return audio
    }
  })
  if (!a) {    
    // trace(getFilePath(sndName))
    a = new Audio(getFilePath(sndName))
    a.sndName = sndName
    audioArr.push(a)
  }
  return a
}

const onWindowFocus = () => {
  windowFocus = true
  playBgSounds()
}
const onWindowBlur = () => {
  stopAllSound()
  windowFocus = false
  bgSoundPlayback = false
}

const getVolume = () => {
  return 1
}

const onInitInteraction = () => {
  trace("## 1 ## on init interaction ")
  $("body").off("click", onInitInteraction)
  playBgSounds()
}

export const playSoundByPath = (path) => {
  if (!soundEnabled || !windowFocus) {
    return
  }
  trace("#% Play: ", path)
  const a = new Audio(path)
  a.volume = getVolume()
  a.play()
}
export const playSound = (sndName) => {
  if (!soundEnabled || !windowFocus) {
    return
  }
  trace("# Play: ", sndName)
  const a = getAudio(sndName)
  if (!a.paused) {
    return false
  }
  a.volume = getVolume()
  a.play()
}


let aCtx, fadeInterval

export const playLoop = (sndName, duration, fade = true) => {
  if (!soundEnabled || !windowFocus) {
    return
  }
  const a = getAudio(sndName)
  if (!a) {
    return false
  }
  if (!a.paused) {
    return false
  }
  clearInterval(a.loopInterval)
  a.loopInterval = setInterval(() => {
    if (!soundEnabled || !windowFocus) {
      clearInterval(a.loopInterval)
      return false
    }
    trace("## 2 ## PLAY!, enabled: ", soundEnabled)
    a.currentTime = 0
    a.play()
  }, duration)

  if (fade) {
    a.volume = 0
    clearInterval(fadeInterval)
    fadeInterval = setInterval(() => {
      if (a) {
        if (a.volume >= .99) {
          clearInterval(fadeInterval)
        } else {
          const newVol = a.volume + 0.02
          a.volume = newVol < 1 ? newVol : 1
        }
      } else {
        clearInterval(fadeInterval)
      }
    }, 80)
  } else {
    if (a) {
      a.volume = getVolume()
    }
  }
  a.play()
}

export const stopSound = (sndName, fade = true) => {
  const a = getAudio(sndName)
  if (a) {
    if (fade && a.volume > 0) {
      clearInterval(fadeInterval)
      fadeInterval = setInterval(() => {
        if (a) {
          if (a.volume <= .05) {
            clearInterval(fadeInterval)
            a.pause()
            a.currentTime = 0
          } else {
            const newVol = a.volume - 0.02
            a.volume = newVol > 0 ? newVol : 0
          }
        } else {
          clearInterval(fadeInterval)
        }
      }, 20)
    } else {
      a.pause()
      a.currentTime = 0
    }
  }
}

export const stopAllSound = (exceptions = [], fade = true) => {
  audioArr.forEach((a, index) => {
    if (exceptions.indexOf(a.sndName) < 0) {
      stopSound(a.sndName, fade)
    }
  })
  // background sound
  if (aCtx) {
    aCtx.close()
  }
}

export const toggleSound = (e) => {
  if (soundEnabled) {
    disableSound()
  } else {
    enableSound()
  }
}
export const isSoundEnabled = () => {
  return soundEnabled
}
export const playBgSounds = () => {
  if (!bgSoundPlayback && soundEnabled) {
    trace("play bg snd loop")
    playLoop(SOUND_PHP_BG, 18000)
    bgSoundPlayback = true
  }
}
export const initSounds = () => {
  if (getCookie(COOKIE_SOUND) == "off") {
    disableSound()
  }
  // first click
  $("body").on("click", onInitInteraction)
  $("body").on("click", ".toggle-audio", onToggleSoundClick)
  $("body").on("click", ".randomize", () => {
    playSound("amzn_scanner_beep")
  })
  // window focus
  window.addEventListener("focus", onWindowFocus, false)
  window.addEventListener("blur", onWindowBlur, false)
}

